<div class="c-toast__message {{ item.toast.type }}"
    *ngFor="let item of toasts; trackBy: trackIdFn"
    #toast>
    <div class="c-toast__message-wrapper">
        <ihd-icon [name]="ICONS[item.toast.type]" class="x-toast-icon {{ item.toast.type }}"></ihd-icon>
        {{ item.toast.msg | translate }}
    </div>

    <ihd-icon name="close" class="c-icon--xs x-toast-close-icon" (click)="close(item)"></ihd-icon>
</div>